export const playBeepingSound = () => {
	const audio = new Audio("/audio/error-tone.mp3");
	audio.play().catch((err) => console.error("Audio play failed:", err));
    setTimeout(() => {
		audio.pause();
		audio.currentTime = 0;
	}, 2500);
};
